// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d0eb4488","182":"d8b23a25","399":"6b5cd5a5","965":"bf1f7aac"}[chunkId] + ".chunk.js";
};